import * as Sentry from '@sentry/react';

const SENTRY_DSN =
  'https://2a42766d25fdff5b1156664fa555dc50@o895196.ingest.us.sentry.io/4510956926271488';

type SentryUser = {
  id?: string;
  profile?: {
    email?: string | null;
    profileName?: string | null;
  } | null;
};

export function initSentry(): void {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Captures PII such as IP addresses by default; disable in privacy-sensitive builds
    sendDefaultPii: true,
    // Only enable Sentry in non-development environments
    enabled: process.env.NODE_ENV !== 'development',
    environment: process.env.NODE_ENV,
    ignoreErrors: [
      'FirebaseError: Remote Config: Error thrown when reading from storage',
      'remoteconfig/storage-get',
      'Data lost due to missing file',
    ],
  });
}

export function setSentryUser(user: SentryUser | null): void {
  if (!user?.id) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.id,
    email: user.profile?.email || undefined,
    username: user.profile?.profileName || undefined,
  });
}
